<script setup>
import People1 from "@/assets/images/desktop/process/people1.svg";
import People2 from "@/assets/images/desktop/process/people2.svg";
import People3 from "@/assets/images/desktop/process/people3.svg";
import People4 from "@/assets/images/desktop/process/people4.svg";

const audiences = [
  { name: "個人買家", icon: People1 },
  { name: "1688批貨小白", icon: People2 },
  { name: "1688批貨老鳥", icon: People3 },
  { name: "小資商家", icon: People4 },
];
</script>

<template>
  <section class="target-section">
    <div class="target-container">
      <p class="process-content">
        只要想在1688上購物 <br />
        都歡迎使用 <span style="color: #3c5bff">CHATxBUY</span>
      </p>

      <div class="people-group">
        <div v-for="person in audiences" :key="person.name" class="people-item">
          <img :src="person.icon" :alt="person.name" />
          <p class="people-content">{{ person.name }}</p>
        </div>
      </div>
      <div class="wh-ellipse"></div>
      <div class="wh-ellipse-mo"></div>
    </div>
  </section>
</template>

<style scoped>
/* Target Section */
.target-container {
  margin-top: 80px;
  position: relative;
}

.process-content {
  font-size: 24px;
  color: #343a40;
  height: auto;
  text-align: center;
  font-weight: 500;
}

.people-group {
  background-color: #ffffff;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.people-content {
  font-size: 20px;
  color: #212529;
}

.wh-ellipse-mo {
  width: 100%;
  height: 160px;
  background-color: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 985px;
  z-index: 1;
}

.wh-ellipse {
  display: none;
}

@media (min-width: 1060px) {
  .target-container {
    margin-top: 80px;
  }

  .process-content {
    font-size: 32px;
  }

  .people-group {
    flex-direction: row;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 47px;
  }

  .people-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .wh-ellipse-mo {
    display: none;
  }

  .wh-ellipse {
    display: block;
    width: 100%;
    height: 190px;
    background-color: #ffffff;
    border-radius: 50%;
    position: absolute;
    top: 21.5rem;
    z-index: 1;
  }
}
</style>
